











export default {
  name: 'CollapseMenuIcon',
  props: {
    color: {
      type: String,
      default: '#B6BEC7'
    }
  }
}
